import * as React from "react";
const SvgDot = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12.0017, cy: 11.9997, r: 2.85714, fill: "#A3A3A3", style: {
  fill: "#A3A3A3",
  fill: "color(display-p3 0.6375 0.6375 0.6375)",
  fillOpacity: 1
} }));
export default SvgDot;
